import { render, staticRenderFns } from "./ModelViewer.vue?vue&type=template&id=6b6ca8d1&scoped=true"
import script from "./ModelViewer.vue?vue&type=script&lang=ts"
export * from "./ModelViewer.vue?vue&type=script&lang=ts"
import style0 from "./ModelViewer.vue?vue&type=style&index=0&id=6b6ca8d1&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ca8d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b6ca8d1')) {
      api.createRecord('6b6ca8d1', component.options)
    } else {
      api.reload('6b6ca8d1', component.options)
    }
    module.hot.accept("./ModelViewer.vue?vue&type=template&id=6b6ca8d1&scoped=true", function () {
      api.rerender('6b6ca8d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ModelViewer.vue"
export default component.exports